import React, { useState, Fragment, useEffect } from 'react';
import {
    Row,
    Input,
    InputGroup,
    InputGroupAddon,
    Label,
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    CustomInput,
    FormGroup,
} from 'reactstrap';
import ImageGallery from '../../gallery/index';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import CategoryLayouts from '../../../../../../data/CategoryLayouts';
import { postAPI_Update_Service_Category } from '../../../../../../constants/APIs';
import Validation from '../../../../../../components/Validation';
import IntlMessages from '../../../../../../helpers/IntlMessages';
export default function CategoryTag({
    visible,
    toggle,
    handleOwnCategoryTag,
    allCategoryData,
    isEdit,
    propertyId,
    LoadData,
    locale,
    languageCode,
    categoryId
}) {
    const [oldTitle, setoldTitle] = useState("0");
    const [categoryList, setCategoryList] = useState([]);
    const [tagData, setTagData] = useState({
        title: "",
        layout: 0,
        languageCode: languageCode,
        displayOrder: 0,
        previewImageText: { subTitle: "", imageUrl: "", buttonText: "" }
    });
    const [galleryVisible, setGalleryVisible] = useState(false);
    const [open, setOpen] = useState(false);
    const [msg, setMsg] = useState([]);

    useEffect(() => {
        var list = [];
        const strAscending = [...allCategoryData].sort((a, b) =>
            a.title > b.title ? 1 : -1,
        );
        strAscending.map((elem) => {
            list.push({
                id: elem.id,
                title: elem.title
            })
        });
        setCategoryList(list);
        if (categoryId !== undefined) {
            setoldTitle(categoryId);
            var data = allCategoryData.filter(i => i.id === categoryId);
            setTagData({
                ...tagData,
                title: data[0].title,
                layout: data[0].layout,
                languageCode: data[0].languageCode,
                displayOrder: data[0].displayOrder,
                previewImageText: data[0].previewImageText
            });
        }
    }, [allCategoryData, categoryId]);
    const handleChange = (e) => {
        setTagData({ ...tagData, layout: parseInt(e.target.value) });
    }
    const handleChangeTitle = (e) => {

        setTagData({
            ...tagData,
            title: e.target.value,
        });
    }

    const togglegallery = () => {
        setGalleryVisible(!galleryVisible);
    };
    const handleChangeSubTitle = (e) => {
        var pre = tagData.previewImageText;
        pre.subTitle = e.target.value;
        setTagData({
            ...tagData,
            previewImageText: pre
        });
    }
    const handleChangeButtonText = (e) => {
        var pre = tagData.previewImageText;
        pre.buttonText = e.target.value;
        setTagData({
            ...tagData,
            previewImageText: pre
        });
    }
    const handleCategoryChange = (e) => {
        setoldTitle(e.target.value);
        var data = allCategoryData.filter(i => i.id === e.target.value);
        setTagData({
            ...tagData,
            title: data[0].title,
            layout: data[0].layout,
            languageCode: data[0].languageCode,
            displayOrder: data[0].displayOrder,
            previewImageText: data[0].previewImageText,
        });
    }
    const selectedImage = (image) => {
        var pre = tagData.previewImageText;
        pre.imageUrl = image.src;
        setTagData({
            ...tagData,
            previewImageText: pre,
        });
    };

    const handleRemoveImage = () => {
        var pre = tagData.previewImageText;
        pre.imageUrl = '';
        setTagData({
            ...tagData,
            previewImageText: pre,
        });
    };
    const getLocalStatement = (statements) => {
        if (statements !== undefined && statements.length > 0) {
            const index = statements.findIndex((m) => m.languageCode === languageCode);
            if (index === -1) {
                const englishIndex = statements.findIndex(
                    (m) => m.languageCode === 'en'
                );
                if (englishIndex !== -1) {
                    return statements[englishIndex].statement;
                }
            } else {
                return statements[index].statement;
            }
        } else {
            return '';
        }
    };
    const handleSubmit = () => {
        var body = {
            ...tagData,
            groupId: getGroupID(),
            propertyId: propertyId === "-1" ? null : propertyId,
            updator: "dashboard"
        }
        AxiosAPI({
            method: 'post',
            url: `${postAPI_Update_Service_Category}`,
            data: body,
        }).then((res) => {
            if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
                && res.data.Messages !== null && res.data.Messages.length > 0) {
                setMsg(res.data.Messages);
                setOpen(true);
            }
            else {
                toggle();
                var categoryId = res.data.id;
                var dat = {
                    id: categoryId,
                    ...tagData
                }
                if (handleOwnCategoryTag !== undefined) {
                    handleOwnCategoryTag(dat);
                }
                if (LoadData !== undefined) {
                    setTimeout(() => {
                        LoadData(languageCode);
                    }, 100);
                }
            }
        }).catch((err) => {
            console.log('err', err);
        });
    }
    const handleUpdate = () => {
        var body = {
            ...tagData,
            id: oldTitle,
            updator: "dashboard"
        }
        console.log(body);
        AxiosAPI({
            method: 'post',
            url: `${postAPI_Update_Service_Category}`,
            data: body,
        }).then((res) => {
            if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
                && res.data.Messages !== null && res.data.Messages.length > 0) {
                setMsg(res.data.Messages);
                setOpen(true);
            } else {
                toggle();
                var categoryId = res.data.id;
                var dat = {
                    id: categoryId,
                    ...tagData
                }
                if (handleOwnCategoryTag !== undefined) {
                    handleOwnCategoryTag(dat);
                }
                if (LoadData !== undefined) {
                    setTimeout(() => {
                        LoadData(languageCode);
                    }, 100);
                }
            }
        }).catch((err) => {
            console.log('err', err);
        });
    }
    const ImageGalleryButton = () => {
        return (
            <Row>
                <Colxx xs="12" sm="12" md="12" lg="12" className="mb-4">
                    <Row>
                        <Colxx xs="12" sm="3" className="mb-1">
                            <Modal
                                isOpen={galleryVisible}
                                toggle={togglegallery}
                                style={{ maxWidth: '1000px' }}
                            >
                                <ModalHeader toggle={togglegallery}>
                                    Select Image or Upload New Image
                                </ModalHeader>
                                <ModalBody>
                                    <ImageGallery
                                        propertyId={propertyId}
                                        selectedImage={selectedImage}
                                        togglegallery={togglegallery}
                                        hideUserUploads={false}
                                        searchText={''}
                                    />
                                </ModalBody>
                            </Modal>
                        </Colxx>
                    </Row>
                </Colxx>
            </Row>
        );
    };
    return (
        <Modal isOpen={visible} toggle={() => toggle()}>
            <ModalHeader toggle={() => toggle()}>Category Tag</ModalHeader>
            <ModalBody>
                <Row>
                    {isEdit === true && (
                        <Fragment>
                            <Colxx sm={12} style={{ marginBottom: "10px" }}>
                                <Label>Select Category</Label>
                                <Input
                                    type="select"
                                    name="oldtitle"
                                    value={oldTitle}
                                    onChange={(e) => handleCategoryChange(e)}
                                ><option value="0">Select</option>
                                    {categoryList.map((item, i) =>
                                        <option value={item.id} key={i}>{item.title}</option>
                                    )}</Input>
                            </Colxx>
                            <Colxx sm={12} style={{ marginBottom: "10px" }}>
                                <Label><IntlMessages id='dashboards.displayOrder' /> </Label>
                                <Input
                                    type="number"
                                    name="displayOrder"
                                    value={tagData.displayOrder}
                                    onChange={(e) => setTagData({ ...tagData, displayOrder: e.target.value })}
                                ></Input>
                            </Colxx>
                        </Fragment>
                    )}
                    <Colxx sm={12} style={{ marginBottom: "10px" }}>
                        <Label>Title</Label>
                        <Input
                            type="text"
                            name="title"
                            value={tagData.title}
                            onChange={(e) => handleChangeTitle(e)}
                        />
                    </Colxx>
                    <Colxx sm={12} style={{ marginBottom: "10px" }}>
                        <Label>Category Layout</Label>
                        {CategoryLayouts.map((item, i) => (
                            <CustomInput
                                key={i}
                                type="radio"
                                name='layout'
                                id={"lauout_" + item.value}
                                value={item.value}
                                label={item.label}
                                checked={item.value === tagData.layout ? true : false}
                                onChange={(e) => handleChange(e)}
                            >
                            </CustomInput>
                        ))}
                    </Colxx>
                    {tagData.layout === 5 &&
                        <Colxx sm={12} style={{ marginBottom: "10px" }}>
                            <Label>Sub Title</Label>
                            <Input
                                type="text"
                                name="title"
                                value={tagData.previewImageText.subTitle}
                                onChange={(e) => handleChangeSubTitle(e)}
                            />
                        </Colxx>}
                    {tagData.layout === 5 || tagData.layout === 6 || tagData.layout === 7 ?
                        <Colxx sm={12} style={{ marginBottom: "10px" }}>
                            <Label className="mt-3">Image Upload</Label>
                            <div className="text-center form-control">
                                {tagData.previewImageText.imageUrl !== null && tagData.previewImageText.imageUrl !== '' ? (
                                    <div className="thumbnail">
                                        <img
                                            className="list-thumbnail responsive border-0"
                                            src={tagData.previewImageText.imageUrl}
                                        />
                                        <a
                                            href="#/"
                                            className="remove"
                                            data-dz-remove
                                            onClick={() => handleRemoveImage()}
                                        >
                                            {' '}
                                            <i className="glyph-icon simple-icon-trash" />{' '}
                                        </a>
                                    </div>
                                ) : (
                                    ''
                                )}
                                <Button
                                    color="secondary"
                                    className="mt-1"
                                    onClick={togglegallery}
                                >
                                    <IntlMessages id='dashboards.browsegallery' />
                                </Button>
                            </div>
                        </Colxx>
                        : null}
                    {tagData.layout === 5 &&
                        <Colxx sm={12} style={{ marginBottom: "10px" }}>
                            <Label>Button Text</Label>
                            <Input
                                type="text"
                                name="buttonText"
                                value={tagData.previewImageText.buttonText}
                                onChange={(e) => handleChangeButtonText(e)}
                            />
                        </Colxx>
                    }
                </Row>
            </ModalBody>
            <ModalFooter>
                {isEdit === true ?
                    <Button
                        color="primary"
                        onClick={() => handleUpdate()}
                    >
                        Update
                    </Button> :
                    <Button
                        color="primary"
                        onClick={() => handleSubmit()}
                    >
                        Add
                    </Button>}

                <Button
                    color="secondary"
                    onClick={() => toggle()}
                >
                    Close
                </Button>
            </ModalFooter>
            {ImageGalleryButton()}
            <Validation open={open} messages={msg} toggle={() => { setOpen(!open) }}></Validation>
        </Modal>
    )
}